/// <amd-module name="Wit/Common/Dictionary" />
export type Dictionary<valueType> = { [key: string]: valueType };
